import {useCallback} from "react";
import {Popup} from "@bryntum/schedulerpro";
import SwivuModal from "./SwivuModal.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";

class ShareSchedulePopup extends Popup {
  static get $name() {
    return "ShareSchedulePopup";
  }

  static get type() {
    return WIDGET_KEYS.swivuShareSchedulePopup;
  }

  static get configurable() {
    return {
      title: "Share",
      autoClose: false,
      draggable: false,
      modal: true,
      cls: "swivu-share-schedule-popup",
      contentElementCls: "p-[3em]",
      closable: true,
      maxWidth: "30em",
      minHeight: "25em",
      items: {
        title: { type: "displayfield", cls: "font-bold text-2xl", value: "Share Schedule" },
        boardTitle: { type: "displayfield", cls: "font-semibold text-lg", value: "" },
        fieldsContainer: {
          type: "container",
          items: {
            agendaResourceUrlField: {
              type: WIDGET_KEYS.fieldCopy,
              editable: false,
              cls: "my-[1em]",
              labelCls: "!self-center",
              label: "Anyone with the link can view this board's schedule.",
              labelPosition: "above",
              name: "url",
            },
            passCodeField: {
              type: WIDGET_KEYS.fieldPassword,
              label: "Optional Passcode (recommended). Case Sensitive.",
              labelPosition: "above",
              labelCls: "!self-center",
              name: "passCode",
              //Bug: When assigning record to `this`, data is mapped to fields but is not updated when value in the field change
              // Applied onChange on fields to update data in record
              onChange: "up.onRecordChange"
            },
            entitySharingCheckbox: {
              type: "checkbox",
              label: "Include Client and Resource Information",
              labelCls: "!self-center !mt-[2em] !mb-0",
              labelPosition: "above",
              name: "isEntitySharing",
              onChange: "up.onRecordChange"
            },
            enableCheckbox: {
              type: "checkbox",
              label: "Enable Schedule Sharing",
              labelCls: "!self-center !mb-0",
              labelPosition: "above",
              name: "isAgendaEnabled",
              onChange: "up.onRecordChange",
            },
          }
        }
      }
    }
  }

  loadRecord(_record, context, _otherParams) {
    this.title = "";
    const { boardTitle } = this.widgetMap;
    this.record = context.project.resourceAgendaStore.first;
    boardTitle.value = context.selectedBoard.name;
    this.swivuCheckGrants(context.user)
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_four)) {
      this.readOnly = true;
    }
  }

  onRecordChange({ value, source }) {
    this.record[source.name] = value;
  }
}

ShareSchedulePopup.initClass();

const SwivuShareSchedulePopup = ({ context, record, onClose, isShow, editorInstance }) => {
  const onShowHandler = useCallback((editor, otherParams = {}) => {
    editor.project = context.project;
    editor.loadRecord(record, context, otherParams);
    editorInstance.editorRef = editor;
  }, [context, editorInstance, record]);

  return (
    <SwivuModal
      widgetType={WIDGET_KEYS.swivuShareSchedulePopup}
      isShow={isShow}
      onHide={onClose}
      onShow={onShowHandler}
    />
  )
}

export default SwivuShareSchedulePopup